import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { Table } from 'components/common/Elements/Elements';

import classes from '../../../AllTenantsTable/AllTenantsTable.module.scss';

const Cell = ({ children, cellClass, cellProps, ...other }) => {
  const { ind, field, row, mouseEnter } = cellProps;
  let newField = field.replace('.', '_');

  return (
    <Table.Cell
      className={cn(
        classes.tableCell,
        row === `r${ind}` && classes.hov,
        classes[newField],
        cellClass
      )}
      onMouseEnter={mouseEnter}
      {...other}
    >
      {children}
    </Table.Cell>
  );
};

Cell.propTypes = {
  children: PropTypes.node,
  cellClass: PropTypes.string,
  cellProps: PropTypes.shape({
    ind: PropTypes.number,
    field: PropTypes.string,
    row: PropTypes.string,
    mouseEnter: PropTypes.func
  })
};

export default Cell;
